import { z } from 'zod'
import { ApiLocale } from '@library/enums'

/** 取得航點清單 - 航點資料 Schema */
const airportDataSchema = z.object({
  /** 區域代碼 */
  areaCode: z.string(),
  /** 國家代碼 */
  countryCode: z.string(),
  /** 地帶代碼 */
  zoneCode: z.string(),
  /** 超額行李區域代碼 */
  pdbgCode: z.string(),
  /** 航線代碼 */
  airlineCode: z.string(),
  /** 代碼 */
  code: z.string(),
  /** 名稱 */
  name: z.string(),
  /** 是否有效 */
  enable: z.boolean()
})

/** 取得航點清單 - 資料 Schema */
export const airportListDataSchema = z.object({
  /** 語系 */
  lang: z.nativeEnum(ApiLocale),
  /** 航點列表 */
  airport: z.array(airportDataSchema)
})

/** 取得航點清單 - 航點資料 */
export interface AirportData extends z.infer<typeof airportDataSchema> {}

/** 取得航點清單 - 資料 */
export interface AirportListData
  extends z.infer<typeof airportListDataSchema> {}
